export default __webpack_public_path__ + "static/media/Set2_Board2.16105a76.png";